<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Section Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <v-text-field
      :value="value.subtitle"
      label="Subtitle"
      outlined
      dense
      @input="update('subtitle', $event)"
    />
    <image-uploader
      :value="value.backgroundImage"
      label="Section Background Image URL"
      @input="update('backgroundImage', $event)"
    />
    <v-slider
      v-if="value.backgroundImage"
      :value="value.bgOpacity !== undefined ? value.bgOpacity : 85"
      label="Background Darken %"
      min="0"
      max="100"
      thumb-label
      dense
      @input="update('bgOpacity', $event)"
    ></v-slider>
    <div class="mb-2 font-weight-medium">Feature Items</div>
    <v-card v-for="(item, i) in items" :key="i" outlined class="mb-2 pa-3">
      <div class="d-flex align-center mb-2">
        <v-select
          :value="item.icon"
          :items="iconList"
          label="Icon"
          outlined
          dense
          hide-details
          class="icon-picker-select"
          style="max-width: 160px; flex: 0 0 160px;"
          @input="updateItem(i, 'icon', $event)"
        >
          <template v-slot:item="data">
            <v-list-item-icon class="mr-2">
              <v-icon small>{{ data.item }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="font-size: 13px;">{{ data.item.replace('mdi-', '') }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:selection="data">
            <v-icon left small>{{ data.item }}</v-icon>
            <span class="text-truncate" style="max-width: 80px; font-size: 12px;">{{ data.item.replace('mdi-', '') }}</span>
          </template>
        </v-select>
        <v-spacer />
        <v-btn icon small color="error" @click="removeItem(i)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
      <v-text-field
        :value="item.title"
        label="Title"
        outlined
        dense
        @input="updateItem(i, 'title', $event)"
      />
      <v-text-field
        :value="item.description"
        label="Description"
        outlined
        dense
        @input="updateItem(i, 'description', $event)"
      />
      <image-uploader
        :value="item.image"
        label="Feature Image (Overrides Icon)"
        @input="updateItem(i, 'image', $event)"
      />
    </v-card>
    <v-btn text small color="primary" @click="addItem">
      <v-icon small left>mdi-plus</v-icon>Add Feature
    </v-btn>
  </div>
</template>

<script>
const ICONS = [
  "mdi-star", "mdi-check-circle", "mdi-heart", "mdi-thumb-up", "mdi-shield-check",
  "mdi-lightbulb-on", "mdi-rocket", "mdi-briefcase", "mdi-bullseye-arrow", "mdi-earth",
  "mdi-fire", "mdi-flash", "mdi-lightning-bolt", "mdi-diamond", "mdi-crown",
  "mdi-gift", "mdi-trophy", "mdi-medal", "mdi-star-face", "mdi-heart-outline",
  "mdi-account", "mdi-account-group", "mdi-account-star", "mdi-account-heart", "mdi-handshake",
  "mdi-chart-line", "mdi-chart-bar", "mdi-chart-pie", "mdi-trending-up", "mdi-currency-usd",
  "mdi-cash", "mdi-wallet", "mdi-percent", "mdi-sale", "mdi-tag",
  "mdi-phone", "mdi-email", "mdi-message", "mdi-chat", "mdi-forum",
  "mdi-bell", "mdi-calendar", "mdi-clock", "mdi-history", "mdi-update",
  "mdi-camera", "mdi-video", "mdi-music", "mdi-image", "mdi-palette",
  "mdi-cog", "mdi-wrench", "mdi-tools", "mdi-hammer", "mdi-screwdriver",
  "mdi-lock", "mdi-key", "mdi-security", "mdi-shield-lock", "mdi-eye",
  "mdi-home", "mdi-domain", "mdi-city", "mdi-store", "mdi-office-building",
  "mdi-truck", "mdi-car", "mdi-airplane", "mdi-bike", "mdi-train",
  "mdi-laptop", "mdi-cellphone", "mdi-tablet", "mdi-monitor", "mdi-television"
];

import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      iconList: ICONS
    };
  },
  computed: {
    items() {
      return this.value.items || [];
    },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    addItem() {
      if (this.items.length > 0) {
        const lastItem = this.items[this.items.length - 1];
        if (!lastItem.title || lastItem.title.trim() === "") {
          this.$swal ? this.$swal("Validation Error", "Please fill the title of the last feature before adding a new one.", "error") : alert("Please fill the title of the last feature before adding a new one.");
          return;
        }
      }
      this.$emit("input", {
        ...this.value,
        items: [...this.items, { icon: "mdi-star", title: "", description: "" }],
      });
    },
    removeItem(i) {
      this.$emit("input", {
        ...this.value,
        items: this.items.filter((_, idx) => idx !== i),
      });
    },
    updateItem(i, key, val) {
      var items = this.items.map((item, idx) =>
        idx === i ? { ...item, [key]: val } : item
      );
      this.$emit("input", { ...this.value, items });
    },
  },
};
</script>
